import { render } from "./zsActivitySignCheck.vue?vue&type=template&id=3f70d289&scoped=true"
import script from "./zsActivitySignCheck.vue?vue&type=script&lang=js"
export * from "./zsActivitySignCheck.vue?vue&type=script&lang=js"

import "./zsActivitySignCheck.vue?vue&type=style&index=0&id=3f70d289&scoped=true&lang=css"

import exportComponent from "E:\\edu-ui\\HyEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3f70d289"]])

export default __exports__